import { useEffect } from "react";
import { Typography } from "@mui/material";

import { generateToken } from "@/utils/services/services-helper";

import { useRouter } from "next/router";
import Head from "next/head";
import styles from "../styles/Home.module.css";

// components
import AvailableStates from "../components/states";
import Container from "../components/container";
import QuestionHeader from "../components/header";

// context
import { BookingContextType } from "utils/booking";
import { useBookingContext } from "../hooks/useBooking";

// =======================================================

const Home = ({ token }: { token: string }) => {
  const context = useBookingContext() as BookingContextType;
  const router = useRouter();
  const hasResults = router?.query?.name && router?.query?.email;

  useEffect(() => {
    context?.reset();
  }, [context]);

  useEffect(() => {
    localStorage.setItem("accessToken", token);
  }, [token]);

  return (
    <div className={styles.main}>
      <Head>
        <title>Thrivelab Booking</title>
        <meta name="description" content="Book your visit" />
        <meta
          name="facebook-domain-verification"
          content="x2k9ywv32ire43lvauzsu03lrpimei"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <QuestionHeader
        hasResults
        onPrevious={
          hasResults
            ? () => {
                history.back();
              }
            : undefined
        }
      />
      <Container sx={{ flex: 1, minHeight: "100vh" }}>
        <Typography
          variant="h4"
          color="primary"
          align="center"
          sx={{ fontFamily: "JazminAlt", fontSize: "35px" }}
        >{`Let's connect you with a provider!`}</Typography>{" "}
        <Typography
          variant="subtitle1"
          color="primary"
          align="center"
          sx={{ opacity: 0.8, mt: 3, fontFamily: "ABCDiaTypeRegular" }}
        >
          Please select your state to check the availability of providers in
          your area.
        </Typography>
        <AvailableStates />
      </Container>
    </div>
  );
};
export async function getServerSideProps() {
  const serviceId = process.env.ITH_SERVICE_ID;
  const token = await generateToken(serviceId!);
  return {
    props: {
      token: token?.accessToken ?? null,
    },
  };
}
export default Home;
